let cache;
async function getCache() {
    if (!cache)
        cache = await caches.open('agreeable');
    return cache;
}
export const cachedValues = {
    get,
    set,
    delete: del,
};
async function get(key, defaultValue) {
    const cache = await getCache();
    const response = await cache.match('/' + key);
    if (response)
        return response.json();
    return defaultValue;
}
async function set(key, value) {
    const cache = await getCache();
    await cache.put('/' + key, new Response(JSON.stringify(value)));
}
async function del(key) {
    const cache = await getCache();
    await cache.delete('/' + key);
}
